import { Injectable } from "@angular/core";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SignalrService {
  public baseURL = `${environment.signalRUrl}`;
  private hubConnection: HubConnection;

  public startConnection = () => {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${this.baseURL}logincheckhub`) // Match your API's URL and hub path
      .build();

    this.hubConnection
      .start()
      .then(() => {
        //console.log('Connection started')
      })
      .catch((err) => {
        //console.log('Error while starting connection: ' + err)
      });
  };

  public receiveDuplicateUser = (
    callback: (userId: string, sessionGuid: string, code: string) => void
  ) => {
    this.hubConnection.off("ReceiveDuplicateUser");
    this.hubConnection.on("ReceiveDuplicateUser", callback);
  };

  public receiveNewUser = (
    callback: (userId: string, sessionGuid: string, code: string) => void
  ) => {
    this.hubConnection.off("ReceiveNewUser");
    this.hubConnection.on("ReceiveNewUser", callback);
  };

  public sendMessage = (user: string, message: string) => {
    this.hubConnection
      .invoke("SendMessage", user, message)
      .catch((err) => console.error(err));
  };
}
